/**
 * Here we return to the beginning of the Chat...
 * Check if there are any simulations pending completion,
 * if so, change the view to bring these simulations in button format
 */
export const startChat = () => {
  return [
    {
      id: 1,
      text: `Olá!`,
      type: 'message-receive'
    },
    {
      id: 2,
      text: '',
      type: 'message-hi-icon'
    },
    {
      id: 3,
      text: 'Que bom ter você por aqui! Sou o assistente virtual da Alelo e hoje vou te ajudar com o seu credenciamento.',
      type: 'message-receive'
    },
    {
      id: 4,
      text: 'Para darmos início, vou precisar que você tenha em mãos as seguintes informações:',
      type: 'message-receive'
    },
    {
      id: 5,
      text: '',
      type: 'message-receive-info-document'
    },
    {
      id: 6,
      text: 'Podemos começar agora?',
      type: 'continue-question'
    }
  ];
};
